module.exports = __webpack_public_path__ + "img/img-2.ce261d54.webp";